document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.getElementById('FacetsWrapperDesktop');
  if (!wrapper) return;

  function closeAll() {
    wrapper.querySelectorAll('.hz-facet-popover').forEach((c) => (c.hidden = true));
    wrapper.querySelectorAll('.hz-facet-btn').forEach((b) => b.setAttribute('aria-expanded', 'false'));
  }

  document.addEventListener('click', (e) => {
    const button = e.target.closest('.hz-facet-btn');
    const insidePopover = e.target.closest('.hz-facet-popover');

    if (button) {
      const filterEl = button.closest('.js-filter');
      const content = filterEl.querySelector('.hz-facet-popover');
      const wasOpen = !content.hidden; // read state BEFORE closing anything

      closeAll();

      if (!wasOpen) {
        content.hidden = false;
        button.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    if (insidePopover) return; // clicking inputs/labels inside the popover shouldn't close it

    closeAll(); // genuine outside click
  }, true);
});